import * as React from 'react';
import { formatRelativeTime } from '@/lib/utils';

export interface RelativeTimeProps {
  date?: string | Date | null;
  className?: string;
}

export const RelativeTime = React.forwardRef<HTMLTimeElement, RelativeTimeProps>(
  ({ date, className }, ref) => {
    if (!date) {
      return <span className={className}>—</span>;
    }
    
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    const relativeTime = formatRelativeTime(dateObj);
    const isoString = dateObj.toISOString();

    return (
      <time
        ref={ref}
        dateTime={isoString}
        className={className}
        title={dateObj.toLocaleString()}
      >
        {relativeTime}
      </time>
    );
  }
);

RelativeTime.displayName = 'RelativeTime';
